import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IActivityLogService } from '../entities/IActivityLogServiceImpl';
import { IActivityLogRepository } from '../entities/IActivityLogRepositoryImpl';
import { ActivityLog, ActivityLogDetails } from '../entities';

export class ActivityLogServiceImpl implements IActivityLogService {
  itemRepo: IActivityLogRepository;

  constructor(ir: IActivityLogRepository) {
    this.itemRepo = ir;

    this.GetActivityLogList = this.GetActivityLogList.bind(this);
    this.GetActivityLogDetails = this.GetActivityLogDetails.bind(this);
  }

  GetActivityLogList(params: {
    pageSize: number;
    pageOffset: number;
    successCallback?: SuccessCallback;
    errorCallback?: ErrorCallback;
  }): Promise<ActivityLog[]> {
    return this.itemRepo.GetActivityLogList(
      params.pageSize,
      params.pageOffset,
      params.successCallback,
      params.errorCallback,
    );
  }

  GetActivityLogDetails(params: {
    id: number;
    successCallback?: SuccessCallback;
    errorCallback?: ErrorCallback;
  }): Promise<ActivityLogDetails> {
    return this.itemRepo.GetActivityLogDetails(params.id, params.successCallback, params.errorCallback);
  }
}
